import { ComponentType, ReactNode, SVGProps } from "react";
import { Box } from "~/components/Box";
import { Card } from "~/components/Card";
import { Flex } from "~/components/Flex";
import { Icon } from "~/components/Icon";
import { Text } from "~/components/Text";
import { H5 } from "~/components/Typography";

export type KPIIconName = ComponentType<SVGProps<SVGSVGElement>>;

export interface KPICardProps {
  label: string;
  value: string;
  iconName?: KPIIconName;
  hint?: ReactNode;
}

export const KPICard = ({ label, value, iconName, hint }: KPICardProps) => (
  <Card css={{ p: "$5", height: "100%" }}>
    <Flex justify="between" align="start" gap="4">
      <Box css={{ minWidth: 0 }}>
        <Text
          variant="dark"
          size="2"
          css={{ fw: "600", textTransform: "uppercase", letterSpacing: "0.04em" }}
        >
          {label}
        </Text>
        <H5 css={{ fw: "700", mt: "$2" }}>{value}</H5>
        {!!hint && (
          <Box css={{ mt: "$2" }}>
            <Text variant="dark" size="2">
              {hint}
            </Text>
          </Box>
        )}
      </Box>
      {!!iconName && <Icon as={iconName} size="lg" variant="primary" />}
    </Flex>
  </Card>
);

KPICard.displayName = "KPICard";
